export default {
  namespaced: true,
  billing_price: {
    title: "Pricing",
    region: "Region",
    security_company: "Security Company",
    description: "Description",
    profile: "Profile",
    hours: "Hours",
    days: "Days",
    cost_per_hour: "Cost per Hour",
    cost_per_shift: "Cost per Shift",
  }
}